function ResidentSearchSundryRowDirective(): ng.IDirective {
    return {
        restrict: "AE",
        scope: {
            resident:"="
        },
        controller: "residentSearchSundryRow.controller",
        controllerAs: "vm",
        replace: false,
        templateUrl: "app/common/directives/partials/residentSearchSundryRow.html"
    };
}

export = ResidentSearchSundryRowDirective;